import React, { Component } from "react";
import { Row, Col, Image } from "antd";
import { Link } from "react-router-dom";
import "../../App.css";

export default class Time extends Component {
  render() {
    return (
      <>
        <Row>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col xs={24} sm={22} md={22} lg={20} xl={20}>
            <Row justify="center">
              <Col span={24} className="paddLR10">
                <Link className="breadCrumbText link" to="/home">
                  Home
                </Link>
                &nbsp;&gt;&nbsp;
                <Link className="breadCrumbText link" to="/Illustration">
                  Illustration
                </Link>
              </Col>
              <Col span={24} className="f4EM fAN color110 paddLR10 paddTop60">
                Times of a Day
              </Col>
              <Col
                span={24}
                className="f1-2EM fVDN color157 paddLR10 paddTop10"
              >
                Studies of how lighting affects color at different times of day.
              </Col>
              <Col span={24} className="paddTop60"></Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
        </Row>
        <Row className="bgColorGray" justify="center">
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col
            xs={24}
            sm={22}
            md={22}
            lg={20}
            xl={20}
            className="paddTop40 paddLR10"
          >
            <Row gutter={[8, 8]}>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Image
                  alt="Time 1 Image"
                  className="img100"
                  src={`${process.env.PUBLIC_URL}/images/jpg/Time1.jpg`}
                  loading="lazy"
                  preview={false}
                  placeholder={
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/Time1_blur.jpg`}
                      preview={false}
                      className="img100"
                    />
                  }
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Image
                  alt="Time 2 Image"
                  className="img100"
                  src={`${process.env.PUBLIC_URL}/images/jpg/Time2.jpg`}
                  loading="lazy"
                  preview={false}
                  placeholder={
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/Time2_blur.jpg`}
                      preview={false}
                      className="img100"
                    />
                  }
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Image
                  alt="Time 3 Image"
                  className="img100"
                  src={`${process.env.PUBLIC_URL}/images/jpg/Time3.jpg`}
                  loading="lazy"
                  preview={false}
                  placeholder={
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/Time3_blur.jpg`}
                      preview={false}
                      className="img100"
                    />
                  }
                />
              </Col>
              <Col xs={24} sm={24} md={24} lg={12} xl={12}>
                <Image
                  alt="Time 4 Image"
                  className="img100"
                  src={`${process.env.PUBLIC_URL}/images/jpg/Time4.jpg`}
                  loading="lazy"
                  preview={false}
                  placeholder={
                    <Image
                      src={`${process.env.PUBLIC_URL}/images/jpg/Time4_blur.jpg`}
                      preview={false}
                      className="img100"
                    />
                  }
                />
              </Col>
            </Row>
          </Col>
          <Col xs={0} sm={1} md={1} lg={2} xl={2}></Col>
          <Col span={24} className="paddTop40"></Col>
        </Row>
        <Row>
          <Col>
            <div className="rH100"></div>
          </Col>
        </Row>
      </>
    );
  }
}
